module.exports = __webpack_public_path__ + "assets/img/code.2c080ae1.png";